import { render, staticRenderFns } from "./f-slug.vue?vue&type=template&id=00fcb4bf&lang=pug&"
import script from "./f-slug.vue?vue&type=script&lang=js&"
export * from "./f-slug.vue?vue&type=script&lang=js&"
import style0 from "./f-slug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fcb4bf')) {
      api.createRecord('00fcb4bf', component.options)
    } else {
      api.reload('00fcb4bf', component.options)
    }
    module.hot.accept("./f-slug.vue?vue&type=template&id=00fcb4bf&lang=pug&", function () {
      api.rerender('00fcb4bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-slug.vue"
export default component.exports